

import { Component,ViewEncapsulation} from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';

import { environment } from '.../../environments/environment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';//added by kuldeep on 10-03-2018
import {MomentDateAdapter} from '@angular/material-moment-adapter';//added by kuldeep on 10-03-2018
import * as _moment from 'moment'; //added by kuldeep on 10-03-2018
import * as _rollupMoment from 'moment';//added by kuldeep on 10-03-2018
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import { AuthService } from '../../../../_services/index';
import { Broadcaster } from '.../../environments/broadcaster';
import { LoaderService } from 'app/_services/loader.service';
import Swal from 'sweetalert2'
var converter = require('number-to-words');
declare var $: any;

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({

    selector: 'createInvoiceLko-cmp',
    templateUrl: './createInvoiceLko.component.html',
    encapsulation: ViewEncapsulation.None ,
    providers: [
      { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
   
  })


  
export class CreateInvoiceLkoComponent {

    arrear:any
    public consumers:any
    public BldTypName:any
    totalAmountInWords:any;
    email:any;
    UCCCategory:any;
    area:any;
    address:any
    GSTIN:any;
    consumerName:any;
    mobileNo:any;
    wardName:any;
    zoneName:any;
    ngxDisabled:any;
    consumerCode:any;
    prjID:any;
    buildingCatogery:any;
    uccCategory:any
    buildingCategoryId:any
    uccCategoryId:any
    itemMaster:any;
    itemDescription:any
    agreedRate;any;
    stdRate:any;
    itemRate:any;
    itemAmount:any
    itemQty:any
    itemDetail:any
    invoiceCGST:any
    invoiceSGST:any
    invoiceIGST:any
    arrearsAmt:any
    taxAmount:any
    subTotal:any
    totalAmount:any
    roundOff:any;
    consumerRefID:any
    itemId:any;
    fromDate:any;
    toDate:any
    invoiceDate:any;
    invoiceDueDate:any
    uom:any;
    userId:any;
    date:any;
    dueDate:any;
    invoiceData:any
    invoiceNo:any
    showLoader:any
    CGST:any;
    SGST:any;
    pinvoiceno :any
    invoiceType :any
    invoiceStatus:any
    authtoken:any
    billingAmount:any
    customerId:any;
    balanceAmount:any
    invoiceMonth:any
    constructor(public routes: ActivatedRoute, public router: Router,public sanitizer: DomSanitizer,public broadcaster: Broadcaster,public auth : AuthService,public http : HttpClient ,public loaderService: LoaderService) {
      
      
     this.authtoken = JSON.parse(localStorage.getItem('authData'));
      this.itemDetail = []
      this.fromDate = new Date();
      this.toDate = new Date()
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      this.date = new Date()
      this.invoiceMonth =  moment(this.fromDate).format('MMMM') +  "-" + moment(this.fromDate).format('YYYY'); 
     
      
     
      this.dueDate = new Date()
      this.invoiceNo = null
      this.pinvoiceno = null
      this.invoiceStatus = 1
      this.loaderService.status.subscribe((val: boolean) => {
          this.showLoader = val;
      });

      // this.pinvoiceno :any
       this.invoiceType = 0
    }
 

    initializeDate(){
      this.fromDate = new Date()
      this.toDate = moment(new Date()).endOf('month') 
      this.dueDate = moment(this.date, "DD-MM-YYYY").add('days', 15);
    }

    invoiceDateChange(data){
      this.dueDate = moment(this.date, "DD-MM-YYYY").add('days', 15);
    }
   
    fromDateChange(data){
      this.invoiceMonth =  moment(this.fromDate).format('MMMM') +  "-" + moment(this.fromDate).format('YYYY'); 
       if(this.itemMaster.length>0){
        this.bindItemData(this.itemMaster)
       }else{
         alert("some internal problem")
       }
       
    }
    toDateChange(data){
      this.invoiceMonth =  moment(this.fromDate).format('MMMM') +  "-" + moment(this.fromDate).format('YYYY'); 
      var monthArray = [31,28,31,30,31,30,31,31,30,31,30,31]
      var lastDate = new Date(this.toDate).getDate()
      var month = new Date(this.toDate).getMonth()
      if(monthArray[month] != lastDate ){
          alert("please select last date of month")
          this.toDate = moment(moment(new Date()).endOf('month')).format("YYYY-MM-DD");
          return;
        }
      if(this.itemMaster.length>0){
        this.bindItemData(this.itemMaster)
       }else{
         alert("some internal problem")
       }
   }


    style(data: string): SafeStyle {
        return this.sanitizer.bypassSecurityTrustStyle(data);
    }
   

    searchConsumer(data){

    }


    selectConsumer(data){
      this.bindconsumerInfo(data)
      this.bindItemData(this.itemMaster)
    }

   





    printInvoice(){
     // $("#InvoiceModal").modal("show")
      this.print()
    }
    print(): void {
       
      let printContents, popupWin;
      printContents = document.getElementById('print-section').innerHTML;
      console.log(printContents)
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
          </head>
      <body onload="window.print();window.close()">${printContents}</body>
        </html>`
      );
      popupWin.document.close();
  }
    saveInvoice(){
      this.loaderService.display(true);
      var data = {
        InvoiceNo:this.invoiceNo,
        PrjId:this.prjID,
        CustomerId :this.customerId,
        InvoiceDate :moment(this.date).format('YYYY-MM-DD'),
        InvoiceMonth : this.invoiceMonth,
        DueDate :moment(this.dueDate).format('YYYY-MM-DD'),
        UccCatId :this.uccCategoryId,
        rate :this.billingAmount,
        Quantity :this.area,
        TotalAmt :this.totalAmount,
        BalanceAmt :this.totalAmount,
        SubTotalAmt :this.subTotal,
        RoundOff :this.roundOff,
        FromDate :moment(this.fromDate).format('YYYY-MM-DD'),
        ToDate:moment(this.toDate).format('YYYY-MM-DD'),
        UserId :this.userId
      }

      this.http.post(environment.apiUrl + 'lko/saveInvoiceLko',data).subscribe(data => {
        this.loaderService.display(false); 
        var response:any
        response = data
        if(response.output[0].RESPONSECODE == 400){
          Swal({ 
            type: 'error',
            title: response.output[1].RESPONSEMESSAGE,
            showConfirmButton: false,
            timer: 10000
          })
        }else{
          Swal({
            type: 'success',
            title: response.output[1].RESPONSEMESSAGE,
            showConfirmButton: false,
            timer: 10000
          })
          if(response.output[2].INVOICENO_RESPONSE == null){
            this.getInvoiceDetails(this.invoiceNo)
          }else{
            this.router.navigate(['/home/crm/kccLko/createInvoiceLko',this.consumerCode,response.output[2].INVOICENO_RESPONSE]);
          }
        }
       
       
      });  
    }

    bindconsumerInfo(data){
      console.log(data)
     
       this.customerId = data.CustomerId
       this.email = data.EmailId;
       this.consumerName = data.CustomerName
       this.buildingCategoryId = data.BLDTypeId;
       this.getUccCategoryType(data.BLDTypeId,data.UCCCATID);
       this.area = data.Area;
       this.billingAmount = data.BillingAmount
    
      
     
       this.address = data.Address;
       this.GSTIN = data.GSTIN;
       this.mobileNo = data.CustomerMobile;
       this.wardName = data.wardName;
       this.zoneName = data.zoneName    
  }



    createConsumer(){
      this.broadcaster.broadcast('addnewConsumer',null);
    }
    editConsumer(consumer){
      this.broadcaster.broadcast('addnewConsumer',consumer);
    }

    
  


    getUccCategoryType(buildCatId,uccCategoryID){ 
        this.http.get(environment.apiUrl + 'consumer/getUccTypeByCatId?categoryId='+ buildCatId+'&prjId='+this.prjID).subscribe(data => {
              this.uccCategory=data;  
              this.uccCategoryId = uccCategoryID
          });  
   }  
    bindUccCategory(data){
      this.uom = data.UOM
      if(data.UOM == null){
        this.agreedRate = 1
      }else{
        this.agreedRate = data.RATE
      }
      this.bindItemData(this.itemMaster)

   }
    getConsumerBuildingCategory(){
        this.http.get(environment.apiUrl + 'consumer/getConsumerBuildingCategoty?prjId='+ this.prjID).subscribe(data =>{
              this.buildingCatogery=data;  
          }); 
    }

    getItemDescription(data){
      console.log(data)
    }

    getMonthDiff(first,last){
      var one = moment(first);
      var two = moment(last);
      var dateDiffs = [];
      var count = Math.round(moment.duration(one.diff(two)).asMonths());

      var month =  two.month() + 1;
      var year  =  two.year();
  for (var i=1; i<=count; i++) {
      if (month > 12) {
        month = 1;
        year++;
      }
      dateDiffs.push(year+"-"+month);
      console.log(month);
      month++;
  }

  console.log(dateDiffs);
    }

    bindItemData(data){
      var rate ;
      this.itemId = data[0].itemId; 
      this.itemDetail = []
      rate = 1
      this.area = 1
     

     // this.getMonthDiff(new Date(this.fromDate),new Date(this.toDate))
      var firstDate = moment(new Date(this.fromDate));
      var endDate = moment(new Date(moment(this.toDate).format("YYYY-MM-DD")))  
      var month = [31,28,31,30,31,30,31,31,30,31,30,31]
      var totalMonth =  endDate.diff(firstDate, 'month');
           var currentDate = new Date(this.fromDate).getDate() 
           var period =  month[new Date(this.fromDate).getMonth()]
           var days = (period - currentDate)  +1
           var days_rate = (this.billingAmount/30)*days
    
            if(totalMonth>0 && days >0){
              if(days == period){
                var amount = (this.billingAmount *this.area)*(totalMonth +1)
                var totalMonthAndDays = totalMonth + 1  + " " + "Month" 
              }else{
                var totalMonthAndDays = totalMonth + " " + "Month" + days + " " +  "days"
                var amount = days_rate*this.area +  (this.billingAmount *this.area)*totalMonth
              }
              
             }
             else if(days == 0){
              var totalMonthAndDays = totalMonth + " " +  "Month" 
              var amount = (this.billingAmount *this.area)*totalMonth
            }else if(totalMonth == 0){
               if(period == days){
                var totalMonthAndDays = "1 Month"
                var amount = (this.billingAmount *this.area)*(totalMonth +1)
               }else{
                var totalMonthAndDays = days + " " +  "days"
                var amount = days_rate*this.area +  (this.billingAmount *this.area)*totalMonth
               }
             
            }
          
        var firstDate = moment(new Date(this.fromDate));
        var endDate = moment(new Date(this.toDate))
        moment(this.date).format('MMMM') +  "-" + moment(this.date).format('YYYY')
      for(var i=0;i<data.length;i++){
          this.subTotal = Number(amount.toFixed(2))
          var item  = {
            itemDescription:data[i].description,
            itemRate: this.billingAmount,
            itemQty:this.area,
            itemAmount: Number(amount.toFixed(2)),
            hsnCD:data[i].hsnCD,
            invoiceMonth: this.invoiceMonth,
            days:totalMonthAndDays
          }
          this.itemDetail.push(item)
      }
 
      var total  = Math.round(amount)
      this.roundOff  = (((amount) - total )).toFixed(2);
      
      this.totalAmount = Number(total) 
      this.loaderService.display(false); 
    }


    getItem(prjID){
      this.http.get(environment.apiUrl + 'invoice/getItem?prjId='+ prjID).subscribe(data =>{
        this.itemMaster = data;
        console.log("itemMaster", this.itemMaster)
        this.bindItemData(this.itemMaster)  
    }); 
    }

    async getConsumersByCode(consumerCode){
      let response = await fetch(environment.apiUrl + "lko/getCustomerById?customerId=" + consumerCode,{
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': this.authtoken.token
        }})
      let consumer  = await response.json()
      consumer.BLDTypeId = JSON.stringify(consumer.BLDTypeId)
      consumer.UCCCATID = JSON.stringify(consumer.UCCCATID)
      let itemResult = await fetch(environment.apiUrl + 'invoice/getItem?prjId='+ this.prjID,{
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': this.authtoken.token
        }})
      let item  = await itemResult.json()
      this.bindconsumerInfo(consumer)
      this.getItem(this.prjID)
      this.loaderService.display(false); 
    }
    bindInvoiceData(data){

      console.log("bindInvoiceData",data)
      this.invoiceData = data
      this.invoiceNo = data.InvoiceNo
      this.customerId = data.CustomerId
      this.consumerName = data.customerName
      this.date = data.InvoiceDate
      this.dueDate = data.DueDate
      this.buildingCategoryId = JSON.stringify(data.BLDTypeId);
      this.getUccCategoryType(data.BLDTypeId,data.UccCatId);
      this.area = data.Quantity
      this.fromDate = data.FromDate
      this.toDate = data.ToDate
      this.billingAmount = data.billingAmount
      this.zoneName = data.zoneName
      this.wardName = data.wardName
      this.arrear = Number(data.Arrear)
      this.invoiceMonth = data.InvoiceMonth
      
    }
      
    
    async getInvoiceDetails(invoiceNo){
      let response = await fetch(environment.apiUrl + "lko/getInvoiceByIdLko?invoiceNo=" + invoiceNo,{
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': this.authtoken.token
        }})
      let invoiceData  = await response.json()
      let data  = invoiceData
      this.bindInvoiceData(data)
      this.getItem(this.prjID)
    }


  
    


    ngOnInit() {
     
      this.prjID = this.auth.getAuthentication().projectId
      this.userId = this.auth.getAuthentication().id
      this.arrear = 0
      this.routes.params.subscribe(params => {
        let invoiceNo = params['invoiceNo']
        if(invoiceNo == "New"){
          this.loaderService.display(true); 
          this.consumerCode = params['consumerCode']
          this.getConsumersByCode(params['consumerCode'])
          this.initializeDate()
        }else{
          this.loaderService.display(true); 
          this.invoiceNo = invoiceNo
          this.getInvoiceDetails(invoiceNo)
        }
       
   });
     
      this.getConsumerBuildingCategory()
    }
     
  }


// WEBPACK FOOTER //
// ./src/app/crm/kccLko/invoiceLko/createInvoiceLko/createInvoiceLko.component.ts